import React, { Component } from 'react';
import moment from 'moment';
import networkList from '../../../constants/networkList';
let dollarIndianLocale = Intl.NumberFormat('en-IN');
const {base_url,homepage } = networkList
class InsurancePreview extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: {},
            patient_validate: false,
            currentDateTime: new Date().toLocaleString()
        }
    }
    componentDidMount() {
        let { insurance_preview_data, patient_validate} = this.props
        this.setState({ 'data': insurance_preview_data, patient_validate: patient_validate, currentDateTime: new Date().toLocaleString() })
        console.log('insurance_preview_data', insurance_preview_data)
    }

    roundAmount(amount) {

        if (amount < 50) {
          return Math.floor(amount / 100) * 100;
        } else {
          return Math.round(amount / 100) * 100;
        }
      }
      
    render() {
        let { data } = this.state
        let user_data
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        const subtotal = this.roundAmount(
            (Number(data['package_amt'] ? data['package_amt'] : data['package_amount']) || 0) + 
            (data['additional_packages'] || []).reduce((acc, feild) => acc + (Number(feild.amount) || 0), 0)
        );
        return (
        <div id='insurancePreview'>
             {data.rn_payer_response === '32' ?
                (
                    <>
                    <React.Fragment>
                        <div className="fc-patient-copy">
                            <div className="p-4 bg-white" id="myH1">
                                <div className="clearfix pt-5">
                                    <img src={`${homepage}/assets/images/units-logo/${user_data["unitid"]&&user_data["unitid"]}.png`} alt="Kims" className="float-left"></img>
                                    <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/03</p>
                                </div>
        
                                <div>
                                    <h1 className="text-p-bold text-center text-uppercase py-4">Financial counselling</h1>
                                </div>
                                <div className="row m-0 pb-3 border">
                                    {data['counselling_date']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Counselling</span>
                                            <span className="w-100">: {moment(data['counselling_date']).format('DD-MM-YYYY')}</span>
                                        </div>
                                    </div>}
                                    {data['counselling_type_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Counselling type</span>
                                            <span className='w-100'>: {data['counselling_type_name']}</span>
                                        </div>
                                    </div>}
                                    {data['umr_no']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">UMR number</span>
                                            <span className='w-100'>: {data['umr_no']}</span>
                                        </div>
                                    </div>}
                                    {data['ip_no']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">IP number</span>
                                            <span className="w-100">: {data['ip_no']}</span>
                                        </div>
                                    </div>}
                                    {data['covid_status']&&<div className="col-4 ">
                                    <div className="d-inline-flex">
                                        <span className="w-label">Covid Status</span>
                                        <span className="w-100">: {data['covid_status'] ?data['covid_status']:''}</span>
                                    </div>
                                </div>}
                                    {data['patient_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Name</span>
                                            <span className="w-100">: {data['patient_name']}</span>
                                        </div>
                                    </div>}
                                    {data['phone_no']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Phone No.</span>
                                            <span className="w-100">: {data['phone_no']}</span>
                                        </div>
                                    </div>}
                                    {data['age']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Age</span>
                                            <span className="w-100">: {data['age']}</span>
                                        </div>
                                    </div>}
                                    {data['doctor_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Doctor Name</span>
                                            <span className="w-100">: {data['doctor_name']}</span>
                                        </div>
                                    </div>}
                                    {data['speciality_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Specialty</span>
                                            <span className="w-100">: {data['speciality_name']}</span>
                                        </div>
                                    </div>}
                                    {data['care_management_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Care Management</span>
                                            <span className="w-100">: {data['care_management_name']}</span>
                                        </div>
                                    </div>}
                                    {data['estimate_type_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimate Type</span>
                                            <span className="w-100">: {data['estimate_type_name']}</span>
                                        </div>
                                    </div>}
                                    {data['payment_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Mode of Payment</span>
                                            <span className="w-100">: {data['payment_name']}</span>
                                        </div>
                                    </div>}
                                    {data['insurance_company_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">TPA </span>
                                            <span className="w-100">: {data['insurance_company_name']}</span>
                                        </div>
                                    </div>}
                                    {data['tpa_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Insurance </span>
                                            <span className="w-100">: {data['tpa_name']}</span>
                                        </div>
                                    </div>}
                                    {data['insurance_status_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Pre Auth Status </span>
                                            <span className="w-100">: {data['insurance_status_name']}</span>
                                        </div>
                                    </div>}
                                    {data['date_of_surgery']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of surgery </span>
                                            <span className="w-100">: { moment(data['date_of_surgery']).format('DD-MM-YYYY')}</span>
                                        </div>
                                    </div>}
                                    {data['e_date_of_admission']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimated Date of Admission</span>
                                            <span className="w-100">: { moment(data['e_date_of_admission']).format('DD-MM-YYYY')}</span>
                                        </div>
                                    </div>}
                                    {data['date_of_admission']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Admission</span>
                                            <span className="w-100">: { moment(data['date_of_admission']).format('DD-MM-YYYY')}</span>
                                        </div>
                                    </div>}
                                    {data['surgery_name']&&<div className="col-8">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Surgery Name </span>
                                            <span className="w-100">: {data['surgery_name']}</span>
                                        </div>
                                    </div>}
                                    {data['length_of_stay']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Length of Stay </span>
                                            <span className="w-100">: {data['length_of_stay']}</span>
                                        </div>
                                    </div>}
                                    {data['room_stay']!==0&& data['room_stay']!=="0.00"&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room</span>
                                            <span className="w-100">: {data['room_stay']}</span>
                                        </div>
                                    </div>}
                                    {data['icu_stay']!==0&& data['icu_stay']!=="0.00"&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU</span>
                                            <span className="w-100">: {data['icu_stay']}</span>
                                        </div>
                                    </div>}
                                    {data['room_eligible_ward_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Eligible Room</span>
                                            <span className="w-100">: {data['room_eligible_ward_name']}</span>
                                        </div>
                                    </div>}
                                    {data['upgrade_room_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Upgraded Room</span>
                                            <span className="w-100">: {data['upgrade_room_name']}</span>
                                        </div>
                                    </div>}
                                    {data['room_upgrade_reason_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Upgrade Reason</span>
                                            <span className="w-100">: {data['room_upgrade_reason_name']}</span>
                                        </div>
                                    </div>}
                                    {data['basic_sum_insured']!==0&& data['basic_sum_insured']!=="0.00"&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Sum Insured </span>
                                            <span className="w-100">: {data['basic_sum_insured']}</span>
                                        </div>
                                    </div>}
                                    {data['balance_sum_insured']!==0&& data['balance_sum_insured']!=="0.00"&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Balance</span>
                                            <span className="w-100">: {data['balance_sum_insured']}</span>
                                        </div>
                                    </div>}
                                    {data['ailment_capping_status_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Ailment Capping </span>
                                            <span className="w-100">:{data['ailment_capping_status_name']}</span>
                                        </div>
                                    </div>}
                                    {(data['ailment_capping_amount']!==0&& data['ailment_capping_amount']!=="0.00")&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Capping Amount</span>
                                            <span className="w-100">: {data['ailment_capping_amount']?parseInt(data['ailment_capping_amount']):'--'}</span>
                                        </div>
                                    </div>}
                                </div>
                                {/* estimate table */}
                                <React.Fragment>
                                    {data.estimate_type == 1 &&<div className="insurance py-2">
                                        <h5 className="data-label w-100">Package:</h5>
                                    </div>}
                                    {data.estimate_type == 1 && <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                                <td className="text-capitalize">Name</td>
                                                <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td className="text-uppercase">{data['package_name']}</td>
                                                <td className="text-capitalize">{dollarIndianLocale.format(this.roundAmount(data['package_amt'] ? data['package_amt'] : data['package_amount']))}</td>
                                            </tr>
                                            {data['additional_packages'] && <React.Fragment>
                                                {data['additional_packages'].map((feild, key) => {
                                                    return (<React.Fragment>
                                                        <tr>
                                                            <td className="text-capitalize" style={{ 'width': '5%' }}>{key + 2}</td>
                                                            <td className="text-capitalize">{feild.package_name}</td>
                                                            <td className="text-capitalize" style={{ 'width': '20%' }}>{dollarIndianLocale.format(this.roundAmount(feild.amount))}</td>
                                                        </tr>
        
                                                        {/* <tr>
                                                            <td></td>
                                                            <td className="text-capitalize">
                                                                {data['excludes_data'] &&
                                                                    <p>Excludes</p>
        
                                                                }
                                                                <table className="table table-hover table-bordered mb-0">
                                                                    {data['excludes_data'] && data['excludes_data'].map((excludes) => {
                                                                        if (feild.package_id == excludes.package_id) {
                                                                            return (<React.Fragment>
                                                                                <tr>
                                                                                    <td className="text-capitalize">{excludes.service_name}</td>
                                                                                </tr>
                                                                            </React.Fragment>)
                                                                        }
        
        
                                                                    })}
                                                                </table>
                                                            </td>
                                                            <td className="text-capitalize">{dollarIndianLocale.format(this.roundAmount(data['header_amount']['room_charges'] + data['header_amount']['room_investigation_charges'] + data['header_amount']['icu_investigation_charges'] + data['header_amount']['ip_pharmacy_charges'] + data['header_amount']['ot_cath_pharmacy'] + data['header_amount']['procedure_charges'] + data['header_amount']['blood_bank_charges']))}</td>
                                                        </tr> */}
        
        
                                                    </React.Fragment>)
                                                })}
                                            </React.Fragment>}
                                            {/* <tr>
                                                <td></td>
                                                <td className="text-capitalize">
                                                    {data['excludes_data'] &&
                                                        <p>Excludes</p>
                                                    }
                                                    <table className="table table-hover table-bordered mb-0">
                                                        {data['excludes_data'] && data['excludes_data'].map((excludes) => {
                                                            if (data['package_id'] == excludes.package_id) {
                                                                return (<React.Fragment>
                                                                    <tr>
                                                                        <td className="text-capitalize">{excludes.service_name}</td>
                                                                    </tr>
                                                                </React.Fragment>)
                                                            }
        
        
                                                        })}
                                                    </table>
                                                </td>
                                                <td className="text-capitalize">{dollarIndianLocale.format(this.roundAmount(data['header_amount']['room_charges'] + data['header_amount']['room_investigation_charges'] + data['header_amount']['icu_investigation_charges'] + data['header_amount']['ip_pharmacy_charges'] + data['header_amount']['ot_cath_pharmacy'] + data['header_amount']['procedure_charges'] + data['header_amount']['blood_bank_charges']))}</td>
                                            </tr>
                                            {(
                                               [
                                                    { id: 1, label: "Room Charges", key: "room_charges" },
                                                    { id: 2, label: "Investigation charges", key: "room_investigation_charges" },
                                                    { id: 3, label: "Service charges", key: "icu_investigation_charges" },
                                                    { id: 4, label: "Pharmacy charges", key: "ip_pharmacy_charges" },
                                                    { id: 5, label: "OT/ Cath Lab charges", key: "ot_cath_pharmacy" },
                                                    { id: 6, label: "Procedure charges", key: "procedure_charges" },
                                                    { id: 7, label: "Other miscellaneous charges", key: "blood_bank_charges" },
                                                ]
                                            ).filter(({ key, key2 }) => {
                                                if (!data["header_amount"]) return false;
                                                const amount = key2
                                                    ? this.roundAmount((data["header_amount"][key] || 0) + (data["header_amount"][key2] || 0))
                                                    : this.roundAmount(data["header_amount"][key] || 0);
                                        
                                                return amount > 0;
                                                }).map(({ id, label, key, key2 }, index) => (
                                                    <tr key={index + 1}>
                                                        <td>{index + 1}</td>
                                                        <td className="text-capitalize">{label}</td>
                                                        <td className="text-uppercase">
                                                        {dollarIndianLocale.format(
                                                            this.roundAmount(
                                                            key2 ? (data["header_amount"][key] || 0) + (data["header_amount"][key2] || 0) : data["header_amount"][key] || 0
                                                            )
                                                        )}
                                                        </td>
                                                    </tr>
                                                )
                                            )} */}
                                        </tbody>
                                    </table>}
                                    {data.estimate_type == 1 && 
                                        <span className="float-right" style={{"margin-right":"15%"}}>
                                        <h4>Sub Total: {dollarIndianLocale.format(subtotal)}</h4>
                                    </span>}
                                    {/* {data.estimate_type == 1  &&data['additional_packages'].length>0&&  <div className="insurance py-2">
                                        <h5 className="data-label w-100">Additional Package:</h5>
                                    </div>}
                                    {data.estimate_type == 1 &&data['additional_packages'].length>0&& <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                                <td className="text-capitalize">Name</td>
                                                <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data['additional_packages'] && <React.Fragment>
                                                {data['additional_packages'].map((feild, key) => {
                                                    return (<React.Fragment>
                                                        <tr>
                                                            <td className="text-capitalize" style={{ 'width': '5%' }}>{key + 1}</td>
                                                            <td className="text-capitalize">{feild.package_name}</td>
                                                            <td className="text-capitalize" style={{ 'width': '20%' }}>{dollarIndianLocale.format(this.roundAmount(feild.amount))}</td>
                                                        </tr>
        
                                                        <tr>
                                                            <td></td>
                                                            <td className="text-capitalize">
                                                                {data['excludes_data'] &&
                                                                    <p>Excludes</p>
        
                                                                }
                                                                <table className="table table-hover table-bordered mb-0">
                                                                    {data['excludes_data'] && data['excludes_data'].map((excludes) => {
                                                                        if (feild.package_id == excludes.package_id) {
                                                                            return (<React.Fragment>
                                                                                <tr>
                                                                                    <td className="text-capitalize">{excludes.service_name}</td>
                                                                                </tr>
                                                                            </React.Fragment>)
                                                                        }
        
        
                                                                    })}
                                                                </table>
                                                            </td>
                                                            <td className="text-capitalize">{dollarIndianLocale.format(this.roundAmount(data['header_amount']['room_charges'] + data['header_amount']['room_investigation_charges'] + data['header_amount']['icu_investigation_charges'] + data['header_amount']['ip_pharmacy_charges'] + data['header_amount']['ot_cath_pharmacy'] + data['header_amount']['procedure_charges'] + data['header_amount']['blood_bank_charges']))}</td>
                                                        </tr>
        
        
                                                    </React.Fragment>)
                                                })}
                                            </React.Fragment>}
                                        </tbody>
                                    </table>} */}
                                    {/* (data.care_management == 1 || data.estimate_type == 2) &&  */}
                                    { <div className="insurance py-2">
                                        <h5 className="data-label w-100" style={{"margin-top": "3%", "margin-bottom": "-2%"}}>Excludes:</h5>
                                    </div>}
                                        {/* { data.estimate_type === 1 ? <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td className="text-capitalize">Consultation fees</td>
                                                <td className="text-uppercase">{data['header_amount'] ? dollarIndianLocale.format(this.roundAmount(data['header_amount']['consultation_charges'])) : 0}</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td className="text-capitalize">Professional fees</td>
                                                <td className="text-uppercase">{data['header_amount'] ? dollarIndianLocale.format(this.roundAmount(data['header_amount']['surgical_charges']+data['header_amount']['medical_charges'])) : 0}</td>
                                            </tr>
                                            </tbody> :  */}
                                        {/* } */}
                                    <span className="float-right" style={{"margin-right":"15.5%"}}>
                                    <h4>Sub Total: {dollarIndianLocale.format(data.estimate_type === 1 ? this.roundAmount( Object.values(data.header_amount || {}).map(val => this.roundAmount(val || 0)).reduce((sum, val) => sum + val, 0)) : 0)}</h4>
                                    </span>
                                    
                                    <div className="clearfix pb-4 bg-white">
                                        <span className="float-left">
                                        </span>
                                        <span className="float-right">
                                        </span>
                                    </div>
                                    
                                    {(data.estimate_type ==2 ||data.estimate_type == 1)&&data['additional_procedures'].length>0&& <div className="insurance py-2">
                                        <h5 className="data-label w-100">Additional  Procedure:</h5>
                                    </div>}
                                    {/* {JSON.stringify(data['additional_packages'])} */}
                                    {(data.estimate_type ==2 ||data.estimate_type == 1)&&data['additional_procedures'].length>0&&<table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                                <td className="text-capitalize">Name</td>
                                                <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data['additional_procedures'] && <React.Fragment>
                                                {data['additional_procedures'].map((feild, key) => {
                                                    return (<React.Fragment>
                                                        <tr>
                                                            <td className="text-capitalize" style={{ 'width': '5%' }}>{key + 1}</td>
                                                            <td className="text-capitalize">{feild.procedure_name}</td>
                                                            <td className="text-capitalize" style={{ 'width': '20%' }}>{dollarIndianLocale.format(this.roundAmount(feild.amount))}</td>
                                                        </tr>
                                                    </React.Fragment>)
                                                })}
                                            </React.Fragment>}
                                        </tbody>
                                    </table>}
                                </React.Fragment>
                                <div className="insurance">
                                    <h5 className="data-label w-100 py-2">Payable by patient:</h5>
                                </div>
                                <table className="table table-hover table-bordered">
                                    <thead>
                                        <tr>
                                            <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                            <td className="text-capitalize">Name</td>
                                            <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td className="text-capitalize">Co-pay</td>
                                            <td className="text-uppercase">{this.roundAmount(data['copay_amount'] ? parseInt((data['copay_amount'])) : 0)}</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td className="text-capitalize">Approx Estimated NME</td>
                                            <td className="text-uppercase">{this.roundAmount(data['nme_amount'] ? parseInt((data['nme_amount'])) : 0)}</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td className="text-capitalize">Room upgrade charges</td>
                                            <td className="text-uppercase">{this.roundAmount(data['room_differance']!=='0.00'&&data['room_differance'] ? parseInt(data['room_differance']) :data['pro_rata_differance']?parseInt(data['pro_rata_differance']):0)}</td>
                                        </tr>
                                        {/* {data['ailment_capping_status_name']==='Yes'&&<tr>
                                            <td>4</td>
                                            <td className="text-capitalize">Difference payable due to Aliment Capping procedure</td>
                                            <td className="text-uppercase">{this.roundAmount(data['differance_amount'] ? parseInt(data['differance_amount'])-(parseInt(data['nme_amount'])+parseInt(data['copay_amount'])+(parseInt(data['room_differance'])!=='0.00'&&data['room_differance']?parseInt(data['room_differance']):data['pro_rata_differance']?data['pro_rata_differance']:0)) : 0)}</td>
                                        </tr>} */}
                                    </tbody>
                                </table>
                                {/* <div className="clearfix pb-4 bg-white">
                                    <span className="float-left">
                                        <h4 className="mb-0">Approx Difference Amount:</h4>
                                    </span>
                                    <span className="float-right">
                                        <h4 className="mb-0">Rs. {Math.round(Number(this.roundAmount( parseInt(data['pro_rata_differance']) + parseInt(data['nme_amount']) + parseInt(data['copay_amount']) )))}</h4>
        
                                    </span>
                                </div> */}
                                <span className="float-right" style={{"margin-right":"15.5%"}}>
                                    <h4>Sub Total: Rs. {Math.round(Number(this.roundAmount( parseInt(data['pro_rata_differance']) + parseInt(data['nme_amount']) + parseInt(data['copay_amount']) )))}</h4>
                                </span>
                                <div className="clearfix pb-4 bg-white" style={{"margin-top": "6%"}}>
                                    <div className="float-left">
                                        <h4 className="mb-0">Total Estimated Amount:</h4>
                                    </div>
                                    <div className="float-right" style={{ marginRight: '13.5%' }}>
                                        <h4 className="mb-0">Rs. {dollarIndianLocale.format(this.roundAmount(data.estimate_type === 1 ? data.total_Estimate_amount : (data.total_Estimate_amount*0.9)))} - {dollarIndianLocale.format(this.roundAmount(data.total_Estimate_amount*1.1))}</h4>
                                    </div>
                                </div>
                            </div></div>
        
                    </React.Fragment>
        
                    <div className="insurance p-4 pt-0 bg-white">
                            {/* <div>
                            <span className="float-left">
                                <h4 className="mb-0">Approx Difference Amount:</h4>
                            </span>
                            </div>
                            <div>
                            <ul className="pl-3"> */}
                        {data.estimate_type == 1 &&
                            <>
                                <h5 className="data-label w-100">General Package Excludes:</h5>
                                <p className="one text-justify">1. Any Investigation or pharmacy item beyond the limit defined in the package.</p>
                                <p className="one text-justify">2. Food & Beverage availed by patient or attendant outside of dietician's plan.</p>
                                <p className="one text-justify">3. Any consultation or procedure done that is outside of the primary line of treatment.</p>
                                <p className="one text-justify">4. Extended stay beyond the duration of the package.</p>
                                <p className="one text-justify">5. Any service rendered during the extended stay (Investigation, Procedure, Doctor Visits).</p>
                                {/* </ul>
                                </div> */}
                            </>
                        }
                        <React.Fragment>
                            <p className="one text-justify">Please note that all the above costs are quoted for the stipulated / tentative length of stay. Increase in length of stay or increase in OT time due to clinical complications / comorbidities will elicit additional charges, depending on the complexity of condition / extension of treatment / period.</p>
                            <ul className="pl-3">
                                <li>For cash paying patients, an advance of 80% of the total estimated amount shall be paid at the time of admission by Cash / Card.</li>
                                <li>All cash paying patients shall maintain a positive cash balance at any time during their stay for treatment in the hospital.</li>
                                <li>Excess Amount paid (up to Rs 10,000) will be refunded to you in cash immediately at the time of final bill clearance. Refunds of amounts more than Rs. 10,000 will be transferred by NEFT within 7 business days.</li>
                                <li>As per section 269 ST, amount upto Rs 1,99,999 only will be accepted by cash. Payments greater than this amount can be done through NEFT / DD / Credit Card / Debit Card.</li>
                            </ul>
                        </React.Fragment>
                        <h5 className="data-label w-100">Declaration:</h5>
                        <p className="one text-justify">I hereby accept that my cashless claim for this admission has been denied by my insurance company. I/We have been explained the above revised estimate breakup as per cash tariff in a language I/We understand in detail. I hereby accept that all the above tariff and breakup was explained to me/us in a language I/We understand in detail. I understand that the
                            amount quoted is only an estimate and the actual charges incurred at the time of the final bill may vary. I take full responsibility of clearing
                            all dues payable to the hospital by arranging payment either by myself or through immediate family of the patient, at the time of discharge / leaving the hospital.</p>
                        <div className="clearfix pt-4">
                            <span className="float-left">
                                Signature: {this.props.digital_sig_imgpath ? <img alt="sign" src={base_url + this.props.digital_sig_imgpath} className="rounded-5 mr-3" width={100} height={80}></img> : '___________________'}
                            </span>
                            <span className="float-right">
                                Signature: ____________________
                            </span>
                        </div>
                        <div className="clearfix pt-4 pb-4">
                            <span className="float-left">
                                Patient/Attendant Name:  {data['attendant_name'] ? data['attendant_name'] : data['patient_name']}
                            </span>
                            <span className="float-right">
                               Counsellor: {data['name_of_the_fc']}
                            </span>
                        </div>
                        <div className="clearfix pt-4 pb-4">
                            {this.props.new_state_value === true ?
                                    (<span className="float-left">
                                        Authorized via single-use verification code <span>{` ${this.props.created_date}`}</span> 
                                    </span>) : null}
                        </div>
                    </div>
                        </>
                ):(
            <>
            <React.Fragment>
                <div className="fc-patient-copy">
                    <div className="p-4 bg-white" id="myH1">
                        <div className="clearfix pt-5">
                            <img src={`${homepage}/assets/images/units-logo/${user_data["unitid"]&&user_data["unitid"]}.png`} alt="Kims" className="float-left"></img>
                            <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/03</p>
                        </div>

                        <div>
                            <h1 className="text-p-bold text-center text-uppercase py-4">Financial counselling</h1>
                        </div>
                        <div className="row m-0 pb-3 border">
                            {data['counselling_date']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Date of Counselling</span>
                                    <span className="w-100">: {moment(data['counselling_date']).format('DD-MM-YYYY')}</span>
                                </div>
                            </div>}
                            {data['counselling_type_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Counselling type</span>
                                    <span className='w-100'>: {data['counselling_type_name']}</span>
                                </div>
                            </div>}
                            {data['umr_no']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">UMR number</span>
                                    <span className='w-100'>: {data['umr_no']}</span>
                                </div>
                            </div>}
                            {data['ip_no']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">IP number</span>
                                    <span className="w-100">: {data['ip_no']}</span>
                                </div>
                            </div>}
                            {data['covid_status']&&<div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Covid Status</span>
                                <span className="w-100">: {data['covid_status'] ?data['covid_status']:''}</span>
                            </div>
                        </div>}
                            {data['patient_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Patient Name</span>
                                    <span className="w-100">: {data['patient_name']}</span>
                                </div>
                            </div>}
                            {data['phone_no']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Patient Phone No.</span>
                                    <span className="w-100">: {data['phone_no']}</span>
                                </div>
                            </div>}
                            {data['age']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Patient Age</span>
                                    <span className="w-100">: {data['age']}</span>
                                </div>
                            </div>}
                            {data['doctor_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Doctor Name</span>
                                    <span className="w-100">: {data['doctor_name']}</span>
                                </div>
                            </div>}
                            {data['speciality_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Specialty</span>
                                    <span className="w-100">: {data['speciality_name']}</span>
                                </div>
                            </div>}
                            {data['care_management_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Care Management</span>
                                    <span className="w-100">: {data['care_management_name']}</span>
                                </div>
                            </div>}
                            {data['estimate_type_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Estimate Type</span>
                                    <span className="w-100">: {data['estimate_type_name']}</span>
                                </div>
                            </div>}
                            {data['payment_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Mode of Payment</span>
                                    <span className="w-100">: {data['payment_name']}</span>
                                </div>
                            </div>}
                            {data['insurance_company_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">TPA </span>
                                    <span className="w-100">: {data['insurance_company_name']}</span>
                                </div>
                            </div>}
                            {data['tpa_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Insurance </span>
                                    <span className="w-100">: {data['tpa_name']}</span>
                                </div>
                            </div>}
                            {data['insurance_status_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Pre Auth Status </span>
                                    <span className="w-100">: {data['insurance_status_name']}</span>
                                </div>
                            </div>}
                            {data['date_of_surgery']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Date of surgery </span>
                                    <span className="w-100">: { moment(data['date_of_surgery']).format('DD-MM-YYYY')}</span>
                                </div>
                            </div>}
                            {data['e_date_of_admission']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Estimated Date of Admission</span>
                                    <span className="w-100">: { moment(data['e_date_of_admission']).format('DD-MM-YYYY')}</span>
                                </div>
                            </div>}
                            {data['date_of_admission']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Date of Admission</span>
                                    <span className="w-100">: { moment(data['date_of_admission']).format('DD-MM-YYYY')}</span>
                                </div>
                            </div>}
                            {data['surgery_name']&&<div className="col-8">
                                <div className="d-inline-flex">
                                    <span className="w-label">Surgery Name </span>
                                    <span className="w-100">: {data['surgery_name']}</span>
                                </div>
                            </div>}
                            {data['length_of_stay']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Length of Stay </span>
                                    <span className="w-100">: {data['length_of_stay']}</span>
                                </div>
                            </div>}
                            {data['room_stay']!==0&& data['room_stay']!=="0.00"&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Room</span>
                                    <span className="w-100">: {data['room_stay']}</span>
                                </div>
                            </div>}
                            {data['icu_stay']!==0&& data['icu_stay']!=="0.00"&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">ICU</span>
                                    <span className="w-100">: {data['icu_stay']}</span>
                                </div>
                            </div>}
                            {data['room_eligible_ward_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Eligible Room</span>
                                    <span className="w-100">: {data['room_eligible_ward_name']}</span>
                                </div>
                            </div>}
                            {data['upgrade_room_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Upgraded Room</span>
                                    <span className="w-100">: {data['upgrade_room_name']}</span>
                                </div>
                            </div>}
                            {data['room_upgrade_reason_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Upgrade Reason</span>
                                    <span className="w-100">: {data['room_upgrade_reason_name']}</span>
                                </div>
                            </div>}
                            {data['basic_sum_insured']!==0&& data['basic_sum_insured']!=="0.00"&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Sum Insured </span>
                                    <span className="w-100">: {data['basic_sum_insured']}</span>
                                </div>
                            </div>}
                            {data['balance_sum_insured']!==0&& data['balance_sum_insured']!=="0.00"&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Balance</span>
                                    <span className="w-100">: {data['balance_sum_insured']}</span>
                                </div>
                            </div>}
                            {data['ailment_capping_status_name']&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Ailment Capping </span>
                                    <span className="w-100">:{data['ailment_capping_status_name']}</span>
                                </div>
                            </div>}
                            {(data['ailment_capping_amount']!==0&& data['ailment_capping_amount']!=="0.00")&&<div className="col-4 ">
                                <div className="d-inline-flex">
                                    <span className="w-label">Capping Amount</span>
                                    <span className="w-100">: {data['ailment_capping_amount']?parseInt(data['ailment_capping_amount']):'--'}</span>
                                </div>
                            </div>}
                        </div>
                        {/* estimate table */}
                        <React.Fragment>
                            {data.estimate_type == 1 &&<div className="insurance py-2">
                                <h5 className="data-label w-100">Package:</h5>
                            </div>}
                            {data.estimate_type == 1 && <table className="table table-hover table-bordered">
                                <thead>
                                    <tr>
                                        <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                        <td className="text-capitalize">Name</td>
                                        <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td className="text-uppercase">{data['package_name']}</td>
                                        <td className="text-capitalize">{dollarIndianLocale.format(this.roundAmount(data['package_amt'] ? data['package_amt'] : data['package_amount']))}</td>
                                    </tr>
                                    {data['additional_packages'] && <React.Fragment>
                                        {data['additional_packages'].map((feild, key) => {
                                            return (<React.Fragment>
                                                <tr>
                                                    <td className="text-capitalize" style={{ 'width': '5%' }}>{key + 2}</td>
                                                    <td className="text-capitalize">{feild.package_name}</td>
                                                    <td className="text-capitalize" style={{ 'width': '20%' }}>{dollarIndianLocale.format(this.roundAmount(feild.amount))}</td>
                                                </tr>

                                                {/* <tr>
                                                    <td></td>
                                                    <td className="text-capitalize">
                                                        {data['excludes_data'] &&
                                                            <p>Excludes</p>

                                                        }
                                                        <table className="table table-hover table-bordered mb-0">
                                                            {data['excludes_data'] && data['excludes_data'].map((excludes) => {
                                                                if (feild.package_id == excludes.package_id) {
                                                                    return (<React.Fragment>
                                                                        <tr>
                                                                            <td className="text-capitalize">{excludes.service_name}</td>
                                                                        </tr>
                                                                    </React.Fragment>)
                                                                }


                                                            })}
                                                        </table>
                                                    </td>
                                                    <td className="text-capitalize">{dollarIndianLocale.format(this.roundAmount(data['header_amount']['room_charges'] + data['header_amount']['room_investigation_charges'] + data['header_amount']['icu_investigation_charges'] + data['header_amount']['ip_pharmacy_charges'] + data['header_amount']['ot_cath_pharmacy'] + data['header_amount']['procedure_charges'] + data['header_amount']['blood_bank_charges']))}</td>
                                                </tr> */}


                                            </React.Fragment>)
                                        })}
                                    </React.Fragment>}
                                    {/* <tr>
                                        <td></td>
                                        <td className="text-capitalize">
                                            {data['excludes_data'] &&
                                                <p>Excludes</p>
                                            }
                                            <table className="table table-hover table-bordered mb-0">
                                                {data['excludes_data'] && data['excludes_data'].map((excludes) => {
                                                    return (<React.Fragment>
                                                        <tr>
                                                            <td className="text-capitalize">{excludes.service_name}</td>
                                                        </tr>
                                                    </React.Fragment>)
                                                })}
                                            </table>
                                        </td>
                                            <td className="text-capitalize">{dollarIndianLocale.format(this.roundAmount(data['header_amount']['room_charges'] + data['header_amount']['room_investigation_charges'] + data['header_amount']['icu_investigation_charges'] + data['header_amount']['ip_pharmacy_charges'] + data['header_amount']['ot_cath_pharmacy'] + data['header_amount']['procedure_charges'] + data['header_amount']['blood_bank_charges']))}</td>
                                    </tr>
                                    {(
                                        [
                                            { id: 1, label: "Room Charges", key: "room_charges" },
                                            { id: 2, label: "Investigation charges", key: "room_investigation_charges" },
                                            { id: 3, label: "Service charges", key: "icu_investigation_charges" },
                                            { id: 4, label: "Pharmacy charges", key: "ip_pharmacy_charges" },
                                            { id: 5, label: "OT/ Cath Lab charges", key: "ot_cath_pharmacy" },
                                            { id: 6, label: "Procedure charges", key: "procedure_charges" },
                                            { id: 7, label: "Other miscellaneous charges", key: "blood_bank_charges" },
                                        ]
                                    ).filter(({ key, key2 }) => {
                                        if (!data["header_amount"]) return false;
                                        const amount = key2
                                            ? this.roundAmount((data["header_amount"][key] || 0) + (data["header_amount"][key2] || 0))
                                            : this.roundAmount(data["header_amount"][key] || 0);
                                
                                        return amount > 0;
                                        }).map(({ id, label, key, key2 }, index) => (
                                            <tr key={index + 1}>
                                                <td>{index + 1}</td>
                                                <td className="text-capitalize">{label}</td>
                                                <td className="text-uppercase">
                                                {dollarIndianLocale.format(
                                                    this.roundAmount(
                                                    key2 ? (data["header_amount"][key] || 0) + (data["header_amount"][key2] || 0) : data["header_amount"][key] || 0
                                                    )
                                                )}
                                                </td>
                                            </tr>
                                        )
                                    )} */}
                                </tbody>
                            </table>}
                            {data.estimate_type == 1 && 
                            <span className="float-right" style={{"margin-right":"15%"}}>
                                <h4>Sub Total: {dollarIndianLocale.format(subtotal)}</h4>
                            </span>}
                            {/* {data.estimate_type == 1  &&data['additional_packages'].length>0&&  <div className="insurance py-2">
                                <h5 className="data-label w-100">Additional Package:</h5>
                            </div>}
                            {data.estimate_type == 1 &&data['additional_packages'].length>0&& <table className="table table-hover table-bordered">
                                <thead>
                                    <tr>
                                        <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                        <td className="text-capitalize">Name</td>
                                        <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data['additional_packages'] && <React.Fragment>
                                        {data['additional_packages'].map((feild, key) => {
                                            return (<React.Fragment>
                                                <tr>
                                                    <td className="text-capitalize" style={{ 'width': '5%' }}>{key + 1}</td>
                                                    <td className="text-capitalize">{feild.package_name}</td>
                                                    <td className="text-capitalize" style={{ 'width': '20%' }}>{dollarIndianLocale.format(this.roundAmount(feild.amount))}</td>
                                                </tr>

                                                <tr>
                                                    <td></td>
                                                    <td className="text-capitalize">
                                                        {data['excludes_data'] &&
                                                            <p>Excludes</p>

                                                        }
                                                        <table className="table table-hover table-bordered mb-0">
                                                            {data['excludes_data'] && data['excludes_data'].map((excludes) => {
                                                                if (feild.package_id == excludes.package_id) {
                                                                    return (<React.Fragment>
                                                                        <tr>
                                                                            <td className="text-capitalize">{excludes.service_name}</td>
                                                                        </tr>
                                                                    </React.Fragment>)
                                                                }


                                                            })}
                                                        </table>
                                                    </td>
                                                    <td className="text-capitalize">{dollarIndianLocale.format(this.roundAmount(data['header_amount']['room_charges'] + data['header_amount']['room_investigation_charges'] + data['header_amount']['icu_investigation_charges'] + data['header_amount']['ip_pharmacy_charges'] + data['header_amount']['ot_cath_pharmacy'] + data['header_amount']['procedure_charges'] + data['header_amount']['blood_bank_charges']))}</td>
                                                </tr>


                                            </React.Fragment>)
                                        })}
                                    </React.Fragment>}
                                </tbody>
                            </table>} */}

                           { <div className="insurance py-2">
                                <h5 className="data-label w-100" style={{"margin-top": "3%", "margin-bottom": "-2%"}}>Excludes:</h5>
                            </div>}
                            
                                {/* { data.estimate_type === 1 ? <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td className="text-capitalize">Consultation fees</td>
                                        <td className="text-uppercase">{data['header_amount'] ? dollarIndianLocale.format(this.roundAmount(data['header_amount']['consultation_charges'])) : 0}</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td className="text-capitalize">Professional fees</td>
                                        <td className="text-uppercase">{data['header_amount'] ? dollarIndianLocale.format(this.roundAmount(data['header_amount']['surgical_charges']+data['header_amount']['medical_charges'])) : 0}</td>
                                    </tr>
                                    </tbody> :  */}
                                    
                            <span className="float-right" style={{"margin-right":"15.5%"}}>
                                <h4>Sub Total: {dollarIndianLocale.format(data.estimate_type === 1 ? this.roundAmount( Object.values(data.header_amount || {}).map(val => this.roundAmount(val || 0)).reduce((sum, val) => sum + val, 0)) : 0)}</h4>
                            </span>

                            <div className="clearfix pb-4 bg-white">
                                <span className="float-left">
                                </span>
                                <span className="float-right">
                                </span>
                            </div>
                            
                            {(data.estimate_type ==2 ||data.estimate_type == 1)&&data['additional_procedures'].length>0&& <div className="insurance py-2">
                                <h5 className="data-label w-100">Additional  Procedure:</h5>
                            </div>}
                            {(data.estimate_type ==2 ||data.estimate_type == 1)&&data['additional_procedures'].length>0&&<table className="table table-hover table-bordered">
                                <thead>
                                    <tr>
                                        <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                        <td className="text-capitalize">Name</td>
                                        <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data['additional_procedures'] && <React.Fragment>
                                        {data['additional_procedures'].map((feild, key) => {
                                            return (<React.Fragment>
                                                <tr>
                                                    <td className="text-capitalize" style={{ 'width': '5%' }}>{key + 1}</td>
                                                    <td className="text-capitalize">{feild.procedure_name}</td>
                                                    <td className="text-capitalize" style={{ 'width': '20%' }}>{dollarIndianLocale.format(this.roundAmount(feild.amount))}</td>
                                                </tr>
                                            </React.Fragment>)
                                        })}
                                    </React.Fragment>}
                                </tbody>
                            </table>}
                        </React.Fragment>
                        <div className="insurance">
                            <h5 className="data-label w-100 py-2">Payable by patient:</h5>
                        </div>
                        <table className="table table-hover table-bordered">
                            <thead>
                                <tr>
                                    <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                    <td className="text-capitalize">Name</td>
                                    <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td className="text-capitalize">Co-pay</td>
                                    <td className="text-uppercase">{this.roundAmount(data['copay_amount'] ? parseInt((data['copay_amount'])) : 0)}</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td className="text-capitalize">Approx Estimated NME</td>
                                    <td className="text-uppercase">{this.roundAmount(data['nme_amount'] ? parseInt((data['nme_amount'])) : 0)}</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td className="text-capitalize">Room upgrade charges</td>
                                    <td className="text-uppercase">{this.roundAmount(data['room_differance']!=='0.00'&&data['room_differance'] ? parseInt(data['room_differance']) :data['pro_rata_differance']?parseInt(data['pro_rata_differance']):0)}</td>
                                </tr>
                                {/* {data['ailment_capping_status_name']==='Yes'&&<tr>
                                    <td>4</td>
                                    <td className="text-capitalize">Difference payable due to Aliment Capping procedure</td>
                                    <td className="text-uppercase">{this.roundAmount(data['differance_amount'] ? parseInt(data['differance_amount'])-(parseInt(data['nme_amount'])+parseInt(data['copay_amount'])+(parseInt(data['room_differance'])!=='0.00'&&data['room_differance']?parseInt(data['room_differance']):data['pro_rata_differance']?data['pro_rata_differance']:0)) : 0)}</td>
                                </tr>} */}
                            </tbody>
                        </table>
                        {/* <div className="clearfix pb-4 bg-white">
                            <span className="float-left">
                                <h4 className="mb-0">Approx Difference Amount:</h4>
                            </span>
                            <span className="float-right">
                                <h4 className="mb-0">Rs. {Math.round(Number(this.roundAmount(data['differance_amount'])))}</h4>

                            </span>
                        </div> */}
                        <span className="float-right" style={{"margin-right":"15.5%"}}>
                            <h4>Sub Total: Rs. {Math.round(Number(this.roundAmount( parseInt(data['pro_rata_differance']) + parseInt(data['nme_amount']) + parseInt(data['copay_amount']) )))}</h4>
                        </span>
                        <div className="clearfix pb-4 bg-white" style={{"margin-top": "6%"}}>
                            <div className="float-left">
                                <h4 className="mb-0">Total Estimated Amount:</h4>
                            </div>
                            <div className="float-right" style={{ marginRight: '13.5%' }}>
                                <h4 className="mb-0">Rs. {dollarIndianLocale.format(this.roundAmount(data.estimate_type === 1 ? data.total_Estimate_amount : (data.total_Estimate_amount*0.9)))} - {dollarIndianLocale.format(this.roundAmount(data.total_Estimate_amount*1.1))}</h4>
                            </div>
                        </div>
                    </div></div>

            </React.Fragment>

            <div className="insurance p-4 pt-0 bg-white">
                    {/* <div>
                    <span className="float-left">
                        <h4 className="mb-0">Approx Difference Amount:</h4>
                    </span>
                    </div>
                    <div>
                    <ul className="pl-3"> */}
                    {data.estimate_type == 1 &&
                        <>
                            <h5 className="data-label w-100">General Package Excludes:</h5>
                            <p className="one text-justify">1. Any Investigation or pharmacy item beyond the limit defined in the package.</p>
                            <p className="one text-justify">2. Food & Beverage availed by patient or attendant outside of dietician's plan.</p>
                            <p className="one text-justify">3. Any consultation or procedure done that is outside of the primary line of treatment.</p>
                            <p className="one text-justify">4. Extended stay beyond the duration of the package.</p>
                            <p className="one text-justify">5. Any service rendered during the extended stay (Investigation, Procedure, Doctor Visits).</p>
                        </>
                    }
                    {/* </ul>
                    </div> */}
                <React.Fragment>
                    <p className="one text-justify">Please note that all the above costs are quoted for the stipulated / tentative length of stay. Increase in length of stay or increase in OT time due to clinical complications / comorbidities will elicit additional charges, depending on the complexity of condition / extension of treatment / period.</p>
                    <ul className="pl-3">
                        <li>For cash paying patients, an advance of 80% of the total estimated amount shall be paid at the time of admission by Cash / Card.</li>
                        <li>All cash paying patients shall maintain a positive cash balance at any time during their stay for treatment in the hospital.</li>
                        <li>Excess Amount paid (up to Rs 10,000) will be refunded to you in cash immediately at the time of final bill clearance. Refunds of amounts more than Rs. 10,000 will be transferred by NEFT within 7 business days.</li>
                        <li>As per section 269 ST, amount upto Rs 1,99,999 only will be accepted by cash. Payments greater than this amount can be done through NEFT / DD / Credit Card / Debit Card.</li>
                    </ul>
                </React.Fragment>
                <h5 className="data-label w-100">Declaration:</h5>
                <p className="one text-justify">I hereby accept that all the above tariff and breakup was explained to me/us in a language I/We understand in detail. I understand that the
                    amount quoted is only an estimate and the actual charges incurred at the time of the final bill may vary. I take full responsibility of clearing
                    all dues payable to the hospital by arranging payment either by myself or through immediate family of the patient, at the time of discharge / leaving the hospital.</p>
                <div className="clearfix pt-4">
                    <span className="float-left">
                        Signature: {this.props.digital_sig_imgpath ? <img alt="sign" src={base_url + this.props.digital_sig_imgpath} className="rounded-5 mr-3" width={100} height={80}></img> : '___________________'}
                    </span>
                    <span className="float-right">
                        Signature: ____________________
                    </span>
                </div>
                <div className="clearfix pt-4 pb-4">
                    <span className="float-left">
                        Patient/Attendant Name:  {data['attendant_name'] ? data['attendant_name'] : data['patient_name']}
                    </span>
                    <span className="float-right">
                       Counsellor: {data['name_of_the_fc']}
                    </span>
                </div>
                <div className="clearfix pt-4 pb-4">
                            {this.props.new_state_value === true ?
                                    (<span className="float-left">
                                        Authorized via single-use verification code <span>{` ${this.props.created_date}`}</span> 
                                    </span>) : null}
                        </div>
                        
            </div>
                </>
                )}
        </div>
           )
    }
}
export default InsurancePreview